export default __webpack_public_path__ + "static/crm_banner-8ead298c96d41cf33f67cdb094c66480.webp";